export const RxFormLabel = {
  styleOverrides: {
    root: {
      transform: 'scale(0.75)',
      transformOrigin: 'top left',
      marginBottom: 6,
    },
  },
};
